<template>
  <div id="app">
    <MadaDates />
  </div>
</template>

<script>
import MadaDates from "@/components/MadaDates";

export default {
  name: 'App',
  components: {
    MadaDates
  }
}
</script>

<style lang="less">
#app {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>
